/**
 * Minimal HTML sanitizer for trusted-ish third-party snippets (HIBP).
 * Strips tags/scripts — prefer plain text over dangerouslySetInnerHTML.
 *
 * @param {unknown} value
 * @returns {string}
 */
export function sanitizeHtmlToText(value) {
  const raw = String(value ?? '');
  if (!raw) return '';
  return raw
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, ' ')
    .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, ' ')
    .replace(/on\w+\s*=\s*(['"]).*?\1/gi, ' ')
    .replace(/<\/?[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
}
